import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './ModalDrawer.module.css';

const modalDrawer = (props) => {
  const modalDrawerClasses = [classes.ModalDrawer, props.className];
  if (props.show === true) {
    modalDrawerClasses.push(classes.Shown);
  } else {
    modalDrawerClasses.push(classes.Hidden);
  }
  if (props.shortWindow === true) modalDrawerClasses.push(classes.ShortWindow);

  const headerClasses = [classes.Header];
  if (props.hideHeader === true) headerClasses.push(classes.HeaderHidden);

  return (
    <div className={modalDrawerClasses.join(' ')}>
      <section className={classes.modalDrawerMain}>
        <div className={headerClasses.join(' ')}>
          <span className={classes.closeModalDrawer} onClick={props.close}>
            {props.hideCaret === true ? null : <FontAwesomeIcon icon="chevron-left" className={classes.CloseDrawer} />}
            {props.closeText ? props.closeText : null}
          </span>
          <h2>{props.title}</h2>
        </div>

        {props.children}
      </section>
    </div>
  );
};

export default modalDrawer;
